import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedGlobals {

constructor() {}

  public eventName = 'BMA';
  public webVersion = true;
  //public slogan: string = '21 - 22 april 2020';
  public slogan: string = '';
  public curDataObj: any = '';
  
  public sharedMap: any = false; //load map instance when ready
  public sharedMarkers = [];
  
  public firstTimeNtfShown = false;
  //public firstTimeNtfTitle = 'Reminder added';
  //public firstTimeNtfText = 'We will notify you 15 minutes before event.';
  
  public menuOpenOnLoad = false;
  public menuIsOpen = true;
  public menusAreSet = false;
  public rootPageWasSet = false;
  public firstPageWasSet = false;
  
  public logoMenu = 'assets/logo/bma_event_logo.png';
  public logoMenuRear = 'assets/logo/bma_event_logo.png';
  public logoToolbar = 'assets/logo/bma_event_logo_short.png';
  public logoUserPages = 'assets/logo/bma_event_logo.png';
  public errorImg = 'assets/imgs/blank.png'; 
  public imgGalUrlBaseDefaultLang = 'https://bma-event.net/bmademo';
  public imgGalUrlBase = 'https://bma-event.net/bmademo';
  public userProfileUrl = 'https://bma-event.net/bmademo/user/'; 
  public userDefaultImg = 'https://bma-event.net/bmademo/pref/imgs/chatterplace.png';
  
  public linksSanitized = false;
  
  public daySorter = 0;
  public ordSorter = '1'; //has to be string
  
  public contentReady = 0;
  public passReady = 0;
  public contentPassReady = 0;
  
  public dateMenuUpdated: any = false;
  public contentUpdated: any = {};
  public contentUpdateInterval = '1';
  
  public lang: any = 'en'; //default
  public languages: any = [];
  
  public backLang = {en: "Back", si: "Nazaj"};
  public logIn = {en: "Log-in", si: "Prijava"};
  
  public globalPreferences: any;
  
  //public menuOpenGlobal: string = '';
  
  public userOn = false;
  public curLoggedUser: string = '';
  
  public favsDict: any = {};
  public favsSharedPreloaded: any = false;
  
  public ratedPostsDict: any = {};
  public ratedPostsSharedPreloaded: any = false;
    
  public subMenus: any = {};
  
  public passkey: string = '';
  public passkey_entered: string = '';
  
  public showEventDates: string = '1';
  public showEventEndDates: string = '1';
  
  public startPage: any = {"menu": "0", "menuItem": "0", "detailId": "-1", "closeMenu": "0"};
  public openDetail = false;
  public notificationPageOpen = false;
  
  
  
  public langDict: any = {
        "Log-in": {
			"en": "Log-in",
			"si": "Vpis v profil"
		},
		"Log-out": {
			"en": "Log-out",
			"si": "Odjava iz profila"
		},
		"Log-out?": {
			"en": "Log-out?",
			"si": "Odjavi iz profila?"
		},
		"Logged out": {
			"en": "Logged out",
			"si": "Odjavljeni ste"
		},
		"Profile deleted": {
			"en": "Profile deleted",
			"si": "Profil izbrisan"
		},
		"Delete profile?": {
			"en": "Delete profile?",
			"si": "Izbriši profil?"
		},
		"Account page": {
			"en": "Account page",
			"si": "Moj profil"
		},
		"Update profile": {
			"en": "Update profile",
			"si": "Shrani profil"
		},
		"Close": {
			"en": "Close",
			"si": "Zapri"
		},
		"Job Title": {
			"en": "Job Title",
			"si": "Zaposlitev"
		},
		"Description": {
			"en": "Description",
			"si": "Opis"
		},
		"Short Description": {
			"en": "Short Description",
			"si": "Kratek opis"
		},
		"Website": {
			"en": "Website",
			"si": "Spletna stran"
		},
		"Phone": {
			"en": "Phone",
			"si": "Telefon"
		},
		"E-mail": {
			"en": "E-mail",
			"si": "E-mail"
		},
		"Skype name": {
			"en": "Skype name",
			"si": "Skype ime"
		},
        "Email": {
			"en": "Email",
			"si": "Email"
		},   
        "Password": {
			"en": "Password",
			"si": "Geslo"
		},
        "Forgot password?": {
			"en": "Forgot password?",
			"si": "Pozabljeno geslo?"
		},
        "Get Help": {
			"en": "Get Help",
			"si": "Kliknite tukaj"
		},
       	"Login": {
			"en": "Login",
			"si": "Prijava"
		},
        "Signup": {
			"en": "Signup",
			"si": "Registracija"
		},
        "Sign up": {
			"en": "Sign up",
			"si": "Registracija"
		},
		"Sign up here": {
			"en": "Sign up here",
			"si": "Registrirajte se"
		},
        "Don't have an account?": {
			"en": "Don't have an account?",
			"si": "Nimate računa?"
		},
		"Or": {
			"en": "Or",
			"si": "Ali"
		},
		"Your profile image has been changed": {
			"en": "Your profile image has been changed",
			"si": "Vaša fotografija je bila spremenjena"
		},
		"Error": {
			"en": "Error",
			"si": "Napaka"
		},
		"Your profile image was not changed": {
			"en": "Your profile image was not changed",
			"si": "Vaša fotografija ni bila spremenjena"
		},
		"Edit": {
			"en": "Edit",
			"si": "Uredi"
		},
        "Cancel": {
			"en": "Cancel",
			"si": "Zavrzi"
		},
        "Updated": {
			"en": "Updated",
			"si": "Posodobljeno"
		},
        "Done": {
			"en": "Done",
			"si": "Končano"
		},
		"Edit Nickname": {
			"en": "Edit Nickname",
			"si": "Uredi prikazno ime"
		},
		"Nickname": {
			"en": "Nickname",
			"si": "Prikazno ime"
		},
        "Name Surename": {
			"en": "Name Surename",
			"si": "Ime Priimek"
		},
		"Your nickname has been changed": {
			"en": "Your nickname has been changed",
			"si": "Vaše prikazno ime je bilo spremenjeno"
		},
		"Your nickname was not changed": {
			"en": "Your nickname was not changed",
			"si": "Vaše prikazno ime ni bilo spremenjeno"
		},
		"Go back": {
			"en": "Go back",
			"si": "Nazaj"
		},
		"All fields are required": {
			"en": "All fields are required",
			"si": "Vsa polja je potrebno izpolniti"
		},
		"Password is not strong. Try giving more than six characters": {
			"en": "Password is not strong. Try giving more than six characters",
			"si": "Geslo ni dovolj močno. Vsebovati mora vsaj 6 znakov"
		},
		"Please wait": {
			"en": "Please wait",
			"si": "Prosim počakajte"
		},
		"E-mail Sent": {
			"en": "E-mail Sent",
			"si": "E-mail poslan"
		},
		"Please follow the instructions in the e-mail to reset your password": {
			"en": "Please follow the instructions in the e-mail to reset your password",
			"si": "Prosimo sledite navodilom v prejetem e-mailu za ponastavitev gesla"
		},
		"Failed": {
			"en": "Failed",
			"si": "Neuspešno"
		},
		"Password Reset": {
			"en": "Password Reset",
			"si": "Ponastavitev gesla"
		},
		"Reset my Password": {
			"en": "Reset my Password",
			"si": "Ponastavi geslo"
		},
		"Social Networks": {
			"en": "Social Networks",
			"si": "Socialna omrežja"
		},
        "Please check your e-mail field": {
			"en": "Please check your e-mail field",
			"si": "Prosimo preverite e-mail format"
		},
		"Please enter valid URL": {
			"en": "Please enter valid URL",
			"si": "Prosimo vnesite pravilno obliko URL naslova "
		},
        "Logged In!": {
            "en": "Logged In!",
			"si": "Prijava uspela"
        },
        "Wrong e-mail or password": {
            "en": "Wrong e-mail or password",
			"si": "Napačno geslo ali e-mail"
        },
        "Delete Profile": {
            "en": "Delete Profile",
			"si": "Izbriši profil"
        },
        "Delete profile action requires fresh log-in": {
            "en": "Delete profile action requires fresh log-in",
			"si": "Za brisanje profila se je potrebno znova vpisati"
        },
        "Delete Your Profile?": {
            "en": "Delete Your Profile?",
			"si": "Želite izbrisati profil?"
        },
        "Yes": {
            "en": "Yes",
			"si": "Da"
        }, 
        "No": {
            "en": "No",
			"si": "Ne"
        },
        "The email address is already in use by another account.": {
            "en": "The email address is already in use by another account.",
			"si": "Ta email je že registriran z drugim profilom"
        },
        "Uploading Image": {
            "en": "Uploading Image",
			"si": "Nalagam sliko"
        },
        "Additional Options": {
            "en": "Additional Options",
			"si": "Dodatno"
        },
        "Save and Close": {
            "en": "Save and Close",
			"si": "Shrani in zapri"
        },
        "Change profile picture": {
            "en": "Change profile picture",
			"si": "Zamenjaj profilno sliko"
        },
        "Take Photo": {
            "en": "Take Photo",
			"si": "Nova fotografija"
        },
        "Pick From Gallery": {
            "en": "Pick From Gallery",
			"si": "Izberi iz galerije"
        },
        "Remove Photo": {
            "en": "Remove Photo",
			"si": "Odstrani fotografijo"
        },
        "Verify e-mail": {
            "en": "Verify e-mail",
			"si": "Potrdite e-mail"
        },
        "Verification link has been sent to your e-mail. Please check your e-mail and complete the verification before logging-in.": {
            "en": "Verification link has been sent to your e-mail. Please check your e-mail and complete the verification before logging-in.",
			"si": "Na vaš e-mail je bila poslana potrditvena povezava. Prosimo, da pred vpisom potrdite e-naslov. Hvala!"
        },
        "Resend Verification E-mail": {
            "en": "Resend Verification E-mail",
			"si": "Ponovno pošlji e-mail"
        },
		"Native function": {
            "en": "Native function",
			"si": "'Native' funkcija"
        },
		"Available in Mobile App": {
            "en": "Available in Mobile App",
			"si": "Na voljo v Appu"
        },
		"Please install App on your Mobile Device to test this functionality": {
            "en": "Please install App on your Mobile Device to test this functionality",
			"si": "Namestite aplikacijo na vašo mobilno napravo za dostop do vseh funkcij"
        },
		"Download App through the AppStore or GooglePlay to test this functionality": {
            "en": "Download App through the AppStore or GooglePlay to test this functionality",
			"si": "Namestite mobilno aplikacijo (preko AppStore oz. GooglePlay) za dostop do vseh funkcij"
        }

	};

	
  

}
